<template>
  <div class="instInputWrap">
    <div class="instCheckBoxFlexWrap">
      <div class="instCheckBoxWrap">
        <input type="checkbox" v-model="absoluteBoxValue.isActive" :true-value="1" :false-value="0">
        <svg viewBox="0 0 37 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:style="{fill:calcFill}" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.504.43C12.767.359 14.027.365 15.29.365h6.396c1.287 0 2.548-.006 3.81.067 1.147.065 2.264.205 3.376.517a11.075 11.075 0 015.864 3.968 11.098 11.098 0 010 13.44 11.08 11.08 0 01-5.864 3.97c-1.112.311-2.23.45-3.376.516-1.262.073-2.523.067-3.785.067h-6.398c-1.286 0-2.546.006-3.809-.067-1.146-.066-2.263-.205-3.376-.517A11.08 11.08 0 010 11.637a11.1 11.1 0 012.265-6.72A11.076 11.076 0 018.128.946c1.113-.311 2.23-.45 3.376-.516z"/></svg>
        <div class="instCheckBoxMarker" v-bind:class="{trueValue: absoluteBoxValue.isActive === 1}"></div>
      </div>
      <p>
        <span>Страхование физических лиц от несчастных случаев и болезней. </span>
        <a href="" v-on:click="absoluteBoxInfo" v-show="!absoluteBoxInfoFlag">Подробнее </a>
        <span v-show="absoluteBoxInfoFlag">Стоимость услуги - {{ absoluteBoxValue.Cost | moneyFormat }} руб. </span>
        <a v-show="absoluteBoxInfoFlag" :href="absoluteFileLink" target="_blank">Правила</a>
      </p>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instAbsoluteBox",
  data() {
    return {
      absoluteBoxInfoFlag: false,
    }
  },
  methods: {
    absoluteBoxInfo($event) {
      $event.preventDefault();
      this.absoluteBoxInfoFlag = true;
    },
  },
  computed: {
    ...mapState({
      boxArr: state => state.instForm.boxArr,
    }),
    absoluteBoxIndex() {
      return this.boxArr.findIndex((item) => item.Id === 4);
    },
    absoluteBoxValue: {
      get() {
        return this.boxArr[this.absoluteBoxIndex];
      },
      set(newValue) {
        this.$store.commit('instUpdateBoxItem', {
          index: this.absoluteBoxIndex,
          value: newValue
        })
      }
    },
    calcFill() {
      if (this.absoluteBoxValue.isActive !== 1 && this.absoluteBoxValue.isActive !== 0) {
        return 'var(--color-gray-type2)'
      }
      return this.absoluteBoxValue.isActive === 1 ? 'var(--color-green)' : 'var(--color-red-type2)';
    },
    absoluteFileLink() {
      return `${process.env.BASE_URL}pdf/Pravila_OOO_Absolyut_strahovaniya.pdf`;
    }
  },
}
</script>
